<template>
    <section class="clientInfo">
		<Nav title="客户详情" />
		<section v-if="!isViewShow"></section>
		<section v-else>
			<section class="order_card">
				<div class="inform">
					<img src="../../assets/img/laba.png">
					未经客户同意不得向第三方提供个人信息，违反者永久封禁账号，并承担相应法律责任
				</div>
				<div class="card">
					<div class="name">
						<p>{{info.basicInfo.name}}</p>
						<!-- <img src="../../assets/img/star45.png"> -->
					</div>
					<div class="date">
						申请时间 {{info.createTime}}
					</div>
					<div class="card_num">
						<div class="money">
							<p>{{info.loanInfo.loanAmount/baseNum|| ''}}<span>万</span></p>
							<p>金额</p>
						</div>
						<div class="money time">
							<p>{{info.loanInfo.loanTerm}}<span>个月</span></p>
							<p>期限</p>
						</div>
						<div class="money">
							<p>{{info.loanInfo.loanPurposeName}}</p>
							<p>目的</p>
						</div>
					</div>
				</div>
			</section>
			<section class="order_form">
				<div class="base_info">
					<div class="tit">
						<p>
							基础信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					<p class="item" v-if="info.basicInfo.age">
						<span>年龄</span>
						<span>{{info.basicInfo.age}}</span>
					</p>
					<p class="item" v-if="info.basicInfo.gender<=3">
						<span>性别</span>
						<span v-if="info.basicInfo.gender==1">男</span>
						<span v-else-if="info.basicInfo.gender==2">女</span>
						<span v-else-if="info.basicInfo.gender==3">未知</span>
					</p>
					<p class="item">
						<span>居住城市</span>
						<span>{{cityStr}}</span>
					</p>
				</div>
				<div class="base_info" v-if="info.productName && info.distributionChannel">
					<div class="tit">
						<p>
							渠道信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					<p class="item" v-if="info.productName">
						<span>产品名称</span>
						<span>{{info.productName}}</span>
					</p>
					<p class="item" v-if="info.distributionChannel">
						<span>投放渠道</span>
						<span>{{info.distributionChannel}}</span>
					</p>
				</div>
				<div class="work_info">
					<div class="tit">
						<p>
							工作信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					<p class="item" v-if="info.workInfo.professionStr">
						<span>职业身份</span>
						<span>{{info.workInfo.professionStr}}</span>
					</p>
					<p class="item" v-if="info.workInfo.income">
						<span>月收入</span>
						<span>{{info.workInfo.income/100}}元</span>
					</p>
					<p class="item" v-if="info.workInfo.formOfIncome">
						<span>工资发放形式</span>
						<span>
							<i v-if="info.workInfo.formOfIncome==1">银行卡</i>
							<i v-else-if="info.workInfo.formOfIncome==2">现金</i>
							<i v-else-if="info.workInfo.formOfIncome==3">自存</i>
						</span>
					</p>

					<p class="item" v-if="info.workInfo.socialStatus && info.workInfo.socialStatus<=3">
						<span>社保</span>
						<span v-if="info.workInfo.socialStatus == 1">
							<i v-if="info.workInfo.socialDetail==1">未满6个月</i>
							<i v-else-if="info.workInfo.socialDetail==2">6个月以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.workInfo.socialStatus == 2">无</span>
						<span v-else-if="info.workInfo.socialStatus==3">未知</span>
					</p>
					<p class="item" v-if="info.workInfo.fundStatus && info.workInfo.fundStatus<=3">
						<span>公积金</span>
						<span v-if="info.workInfo.fundStatus == 1">
							<i v-if="info.workInfo.fundDetail==1">未满6个月</i>
							<i v-else-if="info.workInfo.fundDetail==2">6个月以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.workInfo.fundStatus == 2">无</span>
						<span v-else-if="info.workInfo.fundStatus==3">未知</span>
					</p>
				</div>
				<div class="money_info" v-if="isShowAssets">
					<div class="tit">
						<p>
							资产信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					<p class="item" v-if="info.assetInfo.creditCardStatus && info.assetInfo.creditCardStatus<=3">
						<span>信用卡</span>
						<span v-if="info.assetInfo.creditCardStatus == 1">
							<i v-if="info.assetInfo.creditCardDetail==1">3000元以下</i>
							<i v-else-if="info.assetInfo.creditCardDetail==2">3000-1万元</i>
							<i v-else-if="info.assetInfo.creditCardDetail==3">1-3万元</i>
							<i v-else-if="info.assetInfo.creditCardDetail==4">3万元以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.creditCardStatus == 2">无</span>
						<span v-else-if="info.assetInfo.creditCardStatus==3">未知</span>
					</p>
					
					<p class="item" v-if="info.assetInfo.jieBeiStatus && info.assetInfo.jieBeiStatus<=3">
						<span>借呗额度</span>
						<span v-if="info.assetInfo.jieBeiStatus == 1">
							<i v-if="info.assetInfo.jieBeiDetail==1">3000元以下</i>
							<i v-else-if="info.assetInfo.jieBeiDetail==2">3000-1万元</i>
							<i v-else-if="info.assetInfo.jieBeiDetail==3">1-3万元</i>
							<i v-else-if="info.assetInfo.jieBeiDetail==4">3万元以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.jieBeiStatus == 2">无</span>
						<span v-else-if="info.assetInfo.jieBeiStatus==3">未知</span>
					</p>
					<p class="item"  v-if="info.assetInfo.particleLoanStatus && info.assetInfo.particleLoanStatus<=3">
						<span>微粒贷额度</span>
						<span v-if="info.assetInfo.particleLoanStatus == 1">
							<i v-if="info.assetInfo.particleLoanDetail==1">3000元以下</i>
							<i v-else-if="info.assetInfo.particleLoanDetail==2">3000-1万元</i>
							<i v-else-if="info.assetInfo.particleLoanDetail==3">1-3万元</i>
							<i v-else-if="info.assetInfo.particleLoanDetail==4">3万元以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.particleLoanStatus == 2">无</span>
						<span v-else-if="info.assetInfo.particleLoanStatus==3">未知</span>
					</p>
					<p class="item" v-if="info.assetInfo.sesameStatus && info.assetInfo.sesameStatus<=3">
						<span>芝麻分</span>
						<span v-if="info.assetInfo.sesameStatus == 1">
							<i v-if="info.assetInfo.sesameDetail==1">600分以下</i>
							<i v-else-if="info.assetInfo.sesameDetail==2">600-650分</i>
							<i v-else-if="info.assetInfo.sesameDetail==3">650-700分</i>
							<i v-else-if="info.assetInfo.sesameDetail==4">700分以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.sesameStatus == 2">无</span>
						<span v-else-if="info.assetInfo.sesameStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>


					<p class="item"  v-if="info.assetInfo.houseStatus && info.assetInfo.houseStatus<=3">
						<span>名下房产</span>
						<span v-if="info.assetInfo.houseStatus == 1">
							<i v-if="info.assetInfo.houseDetail==1">有按揭房产</i>
							<i v-else-if="info.assetInfo.houseDetail==2">有全款房产</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.houseStatus == 2">无</span>
						<span v-else-if="info.assetInfo.houseStatus==3">未知</span>
					</p>
					<p class="item"  v-if="info.assetInfo.carStatus && info.assetInfo.carStatus<=3">
						<span>名下车产</span>
						<span v-if="info.assetInfo.carStatus == 1">
							<i v-if="info.assetInfo.carDetail==1">有按揭车产</i>
							<i v-else-if="info.assetInfo.carDetail==2">有全款车产</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.carStatus == 2">无</span>
						<span v-else-if="info.assetInfo.carStatus==3">未知</span>
					</p>
					<p class="item"  v-if="info.assetInfo.insuranceStatus && info.assetInfo.insuranceStatus<=3">
						<span>个人保险</span>
						<span v-if="info.assetInfo.insuranceStatus == 1">
							<i v-if="info.assetInfo.insuranceDetail==1">缴纳未满1年</i>
							<i v-else-if="info.assetInfo.insuranceDetail==2">缴纳1年以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.insuranceStatus == 2">无</span>
						<span v-else-if="info.assetInfo.insuranceStatus==3">未知</span>
					</p>
					<p class="item"  v-if="info.assetInfo.licenseStatus && info.assetInfo.licenseStatus<=3">
						<span>营业执照状态</span>
						<span v-if="info.assetInfo.licenseStatus == 1">
							<i v-if="info.assetInfo.licenseDetail==1">注册未满1年</i>
							<i v-else-if="info.assetInfo.licenseDetail==2">注册1-3年</i>
							<i v-else-if="info.assetInfo.licenseDetail==3">注册3-5年</i>
							<i v-else-if="info.assetInfo.licenseDetail==4">注册5年以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.licenseStatus == 2">无</span>
						<span v-else-if="info.assetInfo.licenseStatus==3">未知</span>
					</p>
				</div>
				<div class="money_info">
					<div class="tit">
						<p>
							接单信息
							<img src="../../assets/img/tit_line.png">
						</p>
						<p class="quit_btn" :style="{color: isQuit?'#7D8290':''}" @click="quitOrder" v-if="!isShow">申请退单</p>
					</div>
					<p class="item">
						<span>接单时间</span>
						<span>{{createTime}}</span>
					</p>
					<p class="item">
						<span>支付金额</span>
						<span>{{amount}}展业币</span>
					</p>
				</div>
				<div class="money_info" v-if="isShow">
					<div class="tit">
						<p>
							退单信息
							<img src="../../assets/img/tit_line.png">
						</p>
						<p @click="lookOrder" class="look_detais">
							查看详情
							<img src="../../assets/img/arrow_right.png">
						</p>
					</div>
					<p class="item">
						<span>退单申请时间</span>
						<span>{{refundTime}}</span>
					</p>
					<p class="item">
						<span>审核状态</span>
						<span class="audit audit1" v-if="refundAuditStatus == 0">
							<img src="../../assets/img/audit1.png">
							审核中
						</span>
						<span class="audit audit2" v-else-if="refundAuditStatus == 30">
							<img src="../../assets/img/audit2.png">
							审核失败
						</span>
						<span class="audit audit3" v-else-if="refundAuditStatus == 20">
							<img src="../../assets/img/audit3.png">
							退单成功
						</span>
					</p>
					<p class="item">
						<span>提示信息</span>
						<span class="hint">{{promptInformation}}</span>
					</p>
				</div>
			</section>
			<!-- <div class="bottom" v-if="!refundAuditStatus && refundAuditStatus!=0"> -->
			<div class="bottom" v-if="refundAuditStatus!=20 && refundAuditStatus !== 0">
				<van-button type="primary" @click="showStrategyModel">
					联系客户
					<a :href="phone" style="color:#fff" v-if="!info.billingStrategy"></a>
				</van-button>
			</div>
		</section>
		<div class="strategy_Model">
			<van-action-sheet v-model="isStrategyModel" :overlay="false" >
				<img src="../../assets/img/strategy_tit.png" class="strategy_tit" />
				<div class="billing_txt">
					<p v-for="item in info.billingStrategyList" :key="item">{{item}}</p>
				</div>
				
				<img src="../../assets/img/strategy_bg.png" class="strategy_bg" />
				<div class="phone_btn" @click="isStrategyModel=false">
					已明白，去开单
					<a :href="phone" style="color:#fff"></a>
				</div>
			</van-action-sheet>
		</div>
		

		<Login :isLoginModel="isLoginModel" :type="type" :topLeftArrow="topLeftArrow" @closeModel="isLoginModel=false"/>
		<van-overlay :show="isOverlay" />
		<section class="dialog"  v-if="isDialog" :class="{'quitDia': isSkip == 2}">
			<h4>退单</h4>
			<div class="primary">
				<p class="text" v-if="isSkip==1">退单规则：接单后3天内，多次联系客户未接通可申请退单</p>
				<p class="text" v-else>申请成功，2个工作日反馈结果</p>
			</div>
			<div class="footer">
				<p class="left" v-if="cancelButtonText" @click="cannelFn">取消</p>
				<p class="right" @click="confirmFn">确定</p>
			</div>
		</section>



	</section>
</template>

<script>
import Nav from "components/Nav"
import Login from "components/Login";
import clienteleServer from "api/clientele";
import { Dialog } from 'vant';



export default {
    name: "clientInfo",
	components: {
		Nav,
		Login,
	},
    data() {
        return {
			phone: '',
			createTime: '',
			amount: '',
			refundTime: '',
			refundRemark: '',
			refundAuditStatus: 20,
			isShow: 0,
			isSkip: 1,
			cityStr: '',
			isViewShow: false,
			info: {
				id: '',
				loanInfo: {},
				workInfo:{},
				basicInfo: {},
				assetInfo:{},
			},
			id: '',
			baseNum: 1000000,
			isLoginModel: false,
			topLeftArrow: true,
			type:'login',
			isDialog: false,
			isOverlay: false,
			promptInformation: '',
			cancelButtonText: true,
			isStrategyModel: false,
			isShowAssets: false,
			isQuit: false,
			
		};
    },
    created() {
		this.id = this.$route.params.id
		this.getInfo()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
    methods: {
		getInfo() {
			clienteleServer.SearchClienteleInfo({orderId: this.id}).then((res) => {
				if(res.data.refundAuditStatus ==null) {
					this.getQuitStatus()
				}
				this.info = res.data.require
				this.createTime = res.data.createTime
				if(res.data.require.workInfo.city) {
					if(res.data.require.workInfo.city.indexOf('-')!=-1) {
						let city = res.data.require.workInfo.city.split('-')
						this.cityStr = city[1]
					}else {
						this.cityStr = res.data.require.workInfo.city
					}
				}
				this.amount = res.data.require.amount
				this.refundTime = res.data.refundTime
				this.refundRemark = res.data.refundRemark
				this.refundAuditStatus = res.data.refundAuditStatus
				this.promptInformation = res.data.promptInformation
				this.phone = `tel:${res.data.require.basicInfo.phone}`
				if(this.info.billingStrategy) {
					this.info.billingStrategyList = []
					this.info.billingStrategyList = this.info.billingStrategy.split('\n')
				}
				for (let key in res.data.require.assetInfo) {
					if(res.data.require.assetInfo[key]) {
						this.isShowAssets = true
					}
				}

				this.isViewShow = true
				if(this.refundAuditStatus == null) {
					this.isShow = false
				}else {
					this.isShow = true
				}
				
			})
		},
		backFn() {

		},
		cannelFn() {
			this.isDialog = false
			this.isOverlay = false
		},
		confirmFn() {
			// if(this.isSkip == 1) {
			// 	clienteleServer.quitClientele({id: this.id}).then(() => {
			// 		this.isSkip = 2
			// 		this.cancelButtonText = false
			// 	}).catch((err) => {
			// 		console.log(err);
			// 	})
			// }else {
			// 	this.isDialog = false
			// 	this.isOverlay = false
			// 	this.cancelButtonText = true
			// 	this.isSkip = 1
			// 	this.getInfo()
			// }
			
			
		},
		showStrategyModel() {
			if(this.info.billingStrategy) {
				this.isStrategyModel = true
			}
		},
		lookOrder() {
			this.$router.push({name: 'quitForm-look',id: this.id})
		},
		getQuitStatus() {
			clienteleServer.SearchQuitStatus({orderId: this.id}).then((res) => {
				if(res.code!=1){
					this.isQuit = true	
				}else {
					this.isQuit = false	
				}
			})
		},
		quitOrder() {
			clienteleServer.SearchQuitStatus({orderId: this.id}).then((res) => {
				if(res.code==20) {
					//出现确认弹框
					Dialog.alert({ title: '退单', message: res.msg})
				}else {
					//退单流程
					if(!this.isShow) {
						this.$router.push({name: 'quitForm-create',id: this.id})
					}else {
						this.$router.push({name: 'quitForm-look', id: this.id})
					}
				}
			}).catch((err) => {
				console.log(err);
			})
			// this.isDialog =true
			// this.isOverlay =true
		},
	},
};
</script>

<style lang="scss">
	.clientInfo {
		padding-top: 46px;
		padding-bottom: 100px;
		i {
			font-style: normal;
		}
		.strategy_Model {
			position: relative;
			.van-action-sheet {
				height: 398px;
			}
			img {
				display: block;
				width: 100%;
			}
			.billing_txt {
				height: 220px;
				overflow-y: scroll;
				p {
					position: relative;
					z-index: 2;
					padding: 0 30px;
					font-size: 15px;
					color: #575F72;
					padding-bottom: 18px;
					
					&:first-of-type {
						padding-top: 20px;
					}

				}
			}
			
			.phone_btn {
				position: relative;
				z-index: 2;
				width: 191px;
				height: 38px;
				line-height: 38px;
				text-align: center;
				margin: 0 auto;
				margin-top: 20px;
				color: #fff;
				background: #3A5EEC;
				border-radius: 50px;
				font-size: 16px;
				font-weight: bold;
				a {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					opacity: 0;
				}
			}
			.strategy_bg {
				position: absolute;
				bottom: 0;
				left: 0;
			}
		}
		
		.order_card {
			height: 196px;
			background: linear-gradient(180deg, #3A5EEC 0%, #5575F5 56%, #F6F6F6 100%);
			.inform {
				padding: 6px 16px;
				position: relative;
				font-size: 14px;
				color: #3A5EEC;
				background: #CDEFFA;
				padding-left: 36px;
				img {
					position: absolute;
					top: 11px;
					left: 15px;
					width: 16px;
				}
			}
			.card {
				margin: 0 15px;
				height: 144px;
				margin-top: 23px;
				background: linear-gradient(180deg, #E6E9ED 0%, #FFFFFF 100%);
				border-radius: 6px;
				border: 1Px solid #FFFFFF;
				padding: 9px 17px;
				.name {
					p {
						color: #2C2D2F;
						font-size: 18px;
						padding-right: 6px;
						display: inline-block;
					}
					img {
						width: 92px;
					}
				}
				.date {
					color: #A2A6AE;
					font-size: 13px;
					padding-top: 2px;
				}
				.card_num {
					padding-top: 15px;
					.money {
						padding-right: 44px;
						display: inline-block;
						&:last-of-type {
							padding-right: 0;
							p {
								&:first-of-type {
									font-size: 23px;
								}
							}
						}
						p {
							&:first-of-type {
								color: #292D37;
								font-size: 26px;
								font-weight: bold;
								span {
									font-size: 16px;
								}
							}
							&:last-of-type {
								color: #A2A6AE;
								font-size: 14px;
							}
						}
					}
					.time {
						padding-right: 63px;
					}
				}
			}
		}
		.order_form {
			padding: 0 15px;
			padding-top: 39px;
			.base_info, .work_info, .money_info {
				padding-bottom: 17px;
				background: #fff;
				border-radius: 4px;
				margin-bottom: 18px;
				.tit {
					position: relative;
					height: 54px;
					margin: 0 11px;
					border-bottom: 1Px solid #F6F6F6;
					display: flex;
					justify-content: space-between;
					align-items: center;
					p {
						position: relative;
						color: #2B2F3A;
						font-size: 16px;
						font-weight: bold;
						img {
							position: absolute;
							bottom: 2px;
							left: -1px;
							width: 66px;
						}
						
					}
					.look_detais {
						display: flex;
						align-items: center;
						color: #7D8290;
						font-weight: normal;
						img {
							margin-left: 4px;
							display: block;
							position: initial;
							width: 7px;
						}
					}
					.quit_btn {
						color: #3A5EEC;
						font-size: 15px;
						font-weight: normal;
					}
				}
				.item {
					padding: 0 17px;
					padding-top: 14px;
					display: flex;
					justify-content: space-between;
					span {
						color: #2B2F3A;
						font-size: 16px;
					}
					.audit {
						display: flex;
						align-items: center;
						font-size: 16px;
						img {
							width: 16px;
							margin-right: 2px;
						}
					}
					.audit1 {
						color: #FF9165;
						img {
							width: 15px;
						}
					}
					.audit2 {
						color: #FD0E2D;
					}
					.audit3 {
						color: #37B457;
					}
					.hint {
						color: #575E72;
					}
				}


			}
			.money_info {

			}

		}
		.bottom{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			.van-button--primary {
				width: 100%;
				height: 46px;
				border-radius: 4px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #FFFFFF;
				border-radius: 0;
				background: #3A5EEC;
			}
			a {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
		}
		.van-dialog {
			.primary {
				.text {
					font-size: 17px;
					color: #7D8290;
					padding: 0 42px;
					text-align: center;
					padding-top: 16px;
					padding-bottom: 32px;
					font-weight: normal;
				}
			}

		}
		.dialog {
			position: fixed;
			z-index: 2001;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			width: 320px;
			height: 208px;
			background: #fff;
			border-radius: 8px;
			h4 {
				font-weight: bold;
				padding-top: 32px;
				text-align: center;
				font-size: 17px;
				color: #2B2F3A;
			}
			.primary {
				padding-top: 16px;
				text-align: center;
				color: #7D8290;
				font-size: 17px;
				p {
					padding: 0 44px;
					color: #7D8290;
					font-size: 17px;
					text-align: center;
					
				}
			}
			.primary_img_run {
				img {
					display: block;
					width: 90px;
					margin: 0 auto;
					margin-top: 23px;
				}
				

			}
			.primary_img_fail, .primary_img_success {
				img {
					display: block;
					width: 102px;
					margin: 0 auto;
					margin-top: 27px;
				}
				p {
					padding-top: 22px;
					color: #7D8290;
					font-size: 16px;
					text-align: center;
				}
			}
			.footer {
				position: absolute;
				bottom: 1px;
				left: 0;
				width: 100%;
				border-top: 1Px solid #eee;
				display: flex;
				height: 55px;
				align-items: center;
				p {
					text-align: center;
					font-size: 17px;
					font-weight: bold;
					height: 55px;
					line-height: 55px;
					flex: 1;
				}
				.left {
					color: #7D8290;
					border-right: 1PX solid #eee;
				}
				.right {
					color: #2B2F3A;
				}
			}



		}
		.quitDia {
			height: 184px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/clientInfo/Info.vue